module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/1_6b5e806e52301891b0c26409909ec0bf.png";